module.exports = __webpack_public_path__ + "static/img/267.09b0639.png";